<div class="card card-custom gutter-b">
    <div class="card-header">
        <div class="card-title">
            <h3 class="card-label">Lista Contracte</h3>
        </div>
        <div class="card-toolbar">
            <a type="button" class="btn text-white blue-bg" routerLink="/sistemerp/contracte/adauga-contract">Adauga
                Contract</a>
        </div>
    </div>
    <div class="card-body">
        <!--Filter-->
        <form #searchForm="ngForm" class="filterForm">
        <div class="row">
            <div class="col-12 mb-5">
                <div class="row">
                    <div class="col-md-3 col-12">
                        <div class="form-group mb-2">
                            <label for="nameFilter" class="sr-only">Nume</label>
                            <input type="text" class="form-control" id="nameFilter" placeholder="Nume"
                                   [(ngModel)]="nameFilter">
                        </div>
                    </div>
                    <div class="col-md-3 col-12">
                        <div class="form-group mx-sm-3 mb-2">
                            <label for="docNumber" class="sr-only">Doc Number</label>
                            <input type="text" class="form-control" id="docNumber" placeholder="Doc Number"
                                   [(ngModel)]="docNumberFilter">
                        </div>
                    </div>
                    <div class="col-md-3 col-12">
                        <div class="form-group mx-sm-3 mb-2">
                            <label for="clientName" class="sr-only">Nume Client</label>
                            <input type="text" class="form-control" id="clientName" placeholder="Nume Client"
                                   [(ngModel)]="clientNameFilter">
                        </div>
                    </div>
                    <div class="col-md-3 col-12">
                        <div class="form-group mx-sm-3 mb-2">
                            <label for="status" class="sr-only">Status</label>
                            <select name="status" id="status" class="form-control" [(ngModel)]="statusFilter">
                                <option value="" selected>Status (-- Alege opțiunea --)</option>
                                <option value="sent">Trimis</option>
                                <option value="archived">Arhivat</option>
                                <option value="accepted">Acceptat</option>
                                <option value="declined">Respins</option>
                            </select>
                        </div>
                    </div>
                    <div class="col-12 mt-4 mb-5">
                        <button class="btn btn-success w-100 font-weight-bold" (click)="listContractFilter()">Cauta
                        </button>
                    </div>
                    <div class="col-12 mb-5">
                        <button class="btn btn-danger w-100 font-weight-bold" (click)="resetForm(searchForm)">Reseteaza
                            Filtrele
                        </button>
                    </div>
                </div>
                <div class="row">
                    <div class="col-md-3 col-12">
                        <div class="form-group mb-2">
                            <label for="sortName" class="sr-only">Sortare dupa</label>
                            <select name="sortName" id="sortName" class="form-control"
                                    (change)="selectSortValue($event)">
                                <option value="" disabled selected>Sortare Dupa</option>
                                <option value="docNumber">Numar Contract</option>
                                <option value="name">Nume</option>
                                <option value="contractDate">Data Postare</option>
                                <option value="clientName">Nume Client</option>
                                <option value="status">Status</option>
                            </select>
                        </div>
                    </div>
                    <div class="col-md-3 col-12">
                        <div class="form-group mb-2">
                            <label for="sortOrder" class="sr-only">Ordinea</label>
                            <select name="sortOrder" id="sortOrder" class="form-control"
                                    (change)="changeOrderDirection($event)">
                                <option value="" selected disabled>Ordinea</option>
                                <option value="desc">Descrescator</option>
                                <option value="asc">Crescator</option>
                            </select>
                        </div>
                    </div>
                    <div class="col-md-3 col-12">
                        <div class="form-group mb-2">
                            <label for="pageElements" class="sr-only">Rezultate</label>
                            <select name="pageElements" id="pageElements" class="form-control"
                                    (change)="selectPageElements($event)">
                                <option value="" disabled selected>Numar Rezultate</option>
                                <option value="3">3</option>
                                <option value="5">5</option>
                                <option value="8">8</option>
                            </select>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        </form>

        <div class="mb-5">
            <label>Nr. Contracte: {{totalElements}}</label>
        </div>

        <!-- begin:Table -->
        <div class="table-responsive angular-bootstrap-table">
            <table class="table table-head-custom table-vertical-center overflow-hidden">
                <thead>
                <th>Nr. Contract</th>
                <th>Nume</th>
                <th>Client</th>
                <th>Data Postare</th>
                <th>Data Expirare</th>
                <th>Pret</th>
                <th>Status</th>
                <th>Actiuni</th>
                </thead>

                <tbody>
                <tr *ngFor="let contracts of contractList">
                    <td>{{contracts.docNumber}}</td>
                    <td>{{contracts.name}}</td>
                    <td>{{contracts.clientName}}</td>
                    <td>{{contracts.contractDate}}</td>
                    <td>{{contracts.deadline}}</td>
                    <td>{{contracts.totalPrice}}€</td>
                    <td>{{contracts.status | enumTransform}}</td>
                    <td>
                        <ul class="list-unstyled mb-0">
                            <li class="list-inline-item">
                                <a routerLink="../contract/{{contracts.id}}"
                                   class="btn btn-icon btn-warning btn-hover-primary btn-sm"
                                   title="Vezi Contract">
                                    <i class="icofont-eye-alt"></i>
                                </a>
                            </li>
                            <li class="list-inline-item">
                                <a routerLink="../editare-contract/{{contracts.id}}"
                                   class="btn btn-icon btn-success btn-hover-primary btn-sm"
                                   title="Editeaza Contract">
                                    <i class="icofont-edit"></i>
                                </a>
                            </li>
                        </ul>
                    </td>
                </tr>
                </tbody>
            </table>
        </div>

        <!-- end: Table -->
        <div class="row">
            <div class="col-12">
                <ngb-pagination class="custom-pagination d-flex justify-content-center"
                                [collectionSize]="totalElements"
                                [(page)]="page"
                                [pageSize]="pageSize"
                                [rotate]="true"
                                [maxSize]="5"
                                [boundaryLinks]="true"
                                (pageChange)="onPageChange(page)"
                                aria-label="Custom pagination">
                    <ng-template ngbPaginationFirst>Prima</ng-template>
                    <ng-template ngbPaginationLast>Ultima</ng-template>
                </ngb-pagination>
            </div>
        </div>
    </div>
</div>
